import OriginalBadge from './Badge.svelte';
import Indicator from './Indicator.svelte';
import Close from './Close.svelte';
const Badge = OriginalBadge;
Badge.Indicator = Indicator;
Badge.Close = Close;
export default Badge;
